import { Env } from "@innojin/shared_front/domain";

import { ENV } from "./env";

// ルール:
// フィーチャーフラグの使用箇所を明確にするため、機能名やそれに準ずる命名をフラグ名として使用する

export const isWakeLockEnabled = () => {
  return ([Env.EnvName.Local] as Env.EnvNameType[]).includes(ENV);
};

// https://www.notion.so/119e6cf8d068806a9a0be02bebf4b994
export const isLanguageSwitcherEnabled = () => {
  return ([Env.EnvName.Local] as Env.EnvNameType[]).includes(ENV);
};

export const isConsultationMenuItem2Enabled = () => {
  return ([Env.EnvName.Local] as Env.EnvNameType[]).includes(ENV);
};

// 予約時の医師選択プルダウン表示可否
export const isSelectDoctorVisibleEnabled = () => {
  return ([Env.EnvName.Local] as Env.EnvNameType[]).includes(ENV);
};

/**
 * @description インバウンド患者のフラグ
 */
export const isInboundEnabled = () => {
  return ([Env.EnvName.Local] as Env.EnvNameType[]).includes(ENV);
};

/**
 * @description オンライン資格確認モックページの有効フラグ
 * prd/stg は外部接続があるため無効
 */
export const isMyNumberMockEnabled = () => {
  return (
    [Env.EnvName.Local, Env.EnvName.Development] as Env.EnvNameType[]
  ).includes(ENV);
};

/**
 * Ponta 薬局の表示フラグ（issue #2931）。
 * 公開前は local / dev のみ表示し、stg / prd では非表示にする。
 * 2026-06-30 夜間リリースで本フラグを削除し、全環境で表示する予定。
 */
export const isPontaPharmacyEnabled = () => {
  return (
    [Env.EnvName.Local, Env.EnvName.Development] as Env.EnvNameType[]
  ).includes(ENV);
};
